import { render, staticRenderFns } from "./TescoMobileRepairHome.vue?vue&type=template&id=2c1be485"
import script from "./TescoMobileRepairHome.vue?vue&type=script&lang=js"
export * from "./TescoMobileRepairHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports